<script lang="ts">
  import type { Envelope } from '$lib/types/public-resources/launches/launch';
  import { gramsToKilograms } from '$lib/utils/unitConversion';
  import QuantitySelector from '../QuantitySelector.svelte';
  import IconTextCardContent from './IconTextCardContent.svelte';

  export let slotIndex: number;
  export let quantity: number;
  export let capacity: number | null;
  export let envelope: Envelope | null;
  let quantitySelectorRef: QuantitySelector;

  export function resetQuantitySelector() {
    quantitySelectorRef.reset();
  }
</script>

<div class="card mt-3 mb-3">
  <div class="card-body">
    <div class="row">
      <div class="col">
        <h5 class="card-title"><strong>Slot Type {slotIndex}</strong></h5>

        {#if capacity !== null}
          <IconTextCardContent icon="weight-hanging" additionalClasses="mb-3">
            <span>Up to {gramsToKilograms(capacity)} kg</span>
          </IconTextCardContent>
        {/if}

        {#if envelope}
          <IconTextCardContent icon="ruler-combined" additionalClasses="mb-3">
            <div class="envelope-container-text">
              <span>{envelope.length} x {envelope.width} x {envelope.height}</span>
              <span class="mt-0 text-muted"><small><em>(L x W x H in cm)</em></small></span>
            </div>
          </IconTextCardContent>
        {/if}

        <IconTextCardContent icon="wrench">
          <span>Mechanical interface coming soon!</span>
        </IconTextCardContent>
      </div>

      <div class="col-auto align-self-center">
        {#key quantity}
          <QuantitySelector bind:this={quantitySelectorRef} on:quantityChange max={quantity}
          ></QuantitySelector>
        {/key}
      </div>
    </div>
  </div>
</div>

<style>
  .row {
    min-height: 162px;
  }

  .card {
    padding: 6px;
    background-color: var(--grey-15);
    border: 0px solid var(--grey-15);
    border-radius: 12px;
  }

  .card-title {
    font-size: 24px;
    margin-bottom: 16px;
  }

  .envelope-container-text {
    line-height: 15px;
    display: inline-grid;
  }

  .envelope-container-text small {
    font-size: 11px;
  }
</style>
